
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import ShopImagesUpload from './ShopImagesUpload.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    ShopImagesUpload,
    Viewer,
  },
})
export default class LookImagesModal extends Vue {
  visible = false;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  shopId!: string;

  @Prop({
    type: Array,
    default: () => [],
  })
  oldHeaderId!: [];

  title = '选择图片';

  @Prop()
  doorFaceImage!: any;

  deleType = true;

  total = 0;

  page = 1;

  lastPage = 0;

  loadType = false;

  lodoing = false;

  draftList = [];

  deleteObjs: any = [];

  data: any = {
    edit: [],
    add: [],
    delete: [],
  };

  p_type: any = '';

  activeKey: any = '0';

  albumId: any = '';

  @Ref('shopImagesUpload')
  shopImagesUpload!: ShopImagesUpload;

  init(name: string, type: any, data: any, albumId?: any) {
    this.title = name;
    this.p_type = type;
    this.visible = true;
    this.data = data;
    const { add, delete: del } = data;
    this.activeKey = '0';
    this.draftList = add;
    this.albumId = albumId;
    this.deleteObjs = del;
    this.selectedKeys = del.map((item: any) => item.resource_id);
    // this.listData = this.listDasssta;
    this.page = 1;
    this.lastPage = 1;
    if (albumId) {
      const params = {
        albumId,
        page: 1,
        pageSize: 10,
        shopId: this.shopId,
      };
      if (albumId) {
        this.getAlbumList(params);
      }
    }
  }


  async getAlbumList(params: any) {
    const res = await this.shopService.albumShopOfficialInfo(params);
    this.listData = [...this.listData, ...res.list];
    this.total = res.total;
    this.lodoing = false;
    this.lastPage = res.lastPage;
    if (params.page < res.lastPage) {
      this.loadType = true;
    } else {
      this.loadType = false;
    }
  }

  funDelete() {
    this.deleType = false;
  }


  setStorefront(id: any, type: any) {
    // console.log(id);
    this.$emit('setStorefront', id, type);
  }

  /**
   * 同步状态
   */
  synStatus() {
    // console.log('同步状态');
  }

  funTDelete() {
    this.deleType = true;
  }

  handleOk() {
    this.visible = false;
    this.data.delete = this.deleteObjs;
    this.data.add = this.draftList;
    this.$emit('submit', this.p_type, this.data);
    this.listData = [];
    this.draftList = [];
  }

  handleCancel() {
    this.visible = false;
    this.draftList = [];
    this.selectedKeys = [];
    this.deleteObjs = [];
    this.listData = [];
    this.loadType = false;
    this.lodoing = false;
    this.page = 1;
    this.lastPage = 1;
    this.deleType = true;
  }

  uploadImage() {
    this.shopImagesUpload.init(this.title);
  }

  callback(key: string) {
    this.activeKey = key;
    this.listData = [];
    if (key === '5') {
      this.listData = this.draftList;
    } else {
      const params = {
        albumId: this.albumId,
        page: 1,
        pageSize: 10,
        audit_status: key !== '0' ? key : '',
        shopId: this.shopId,
      };
      this.page = 1;
      // this.listData = this.listDasssta;
      if (this.albumId) {
        this.getAlbumList(params);
      }
    }
  }
  listData: any = [];
  listDasssta = [];

  // 已选中的 key 数组
  selectedKeys: string[] = [];

  draftKeys: string[] = [];
  handleCheck(key: any): void {
    if (this.activeKey === '5') {
      const index = this.draftKeys.indexOf(key.resource_id);
      if (index > -1) {
        // 已选中，取消
        this.draftKeys.splice(index, 1);
      } else {
        // 未选中，加入
        this.draftKeys.push(key.resource_id);
      }
    } else {
      const index = this.selectedKeys.indexOf(key.resource_id);
      if (index > -1) {
        // 已选中，取消
        this.selectedKeys.splice(index, 1);
        this.deleteObjs = this.deleteObjs.filter((item: any) => item.resource_id !== key.resource_id);
      } else {
        // 未选中，加入
        this.selectedKeys.push(key.resource_id);
        this.deleteObjs.push(key);
      }
    }
  }

  funSynch() {
    // console.log('同步状态');
  }
  edit() {
    // console.log('编辑');
  }
  dele() {
    // console.log('删除');
  }
  lookReason() {
  }
  changeImg(img: any) {
    this.activeKey = '5';
    if (this.activeKey === '5') {
      this.listData = img;
    }
    this.draftList = img;
  }

  delteItem(key: any) {
    this.selectedKeys.push(key.resource_id);
    this.deleteObjs.push(key);
  }

  deleteImage() {
    this.draftKeys.forEach((element: any) => {
      this.draftList = this.draftList.filter((item: any) => item.resource_id !== element);
    });
    this.listData = this.draftList;
  }

  cancelPage() {
    if (this.activeKey === '5') {
      const idsToRemove = new Set(this.listData.map((item: any) => item.resource_id));
      const result = this.draftKeys.filter((item) => !idsToRemove.has(item));
      this.draftKeys = result;
    } else {
      const idsToRemove = new Set(this.listData.map((item: any) => item.resource_id));
      const result = this.selectedKeys.filter((item) => !idsToRemove.has(item));
      const deleteObjs = this.deleteObjs.filter((item: any) => !idsToRemove.has(item.resource_id));
      this.selectedKeys = result;
      this.deleteObjs = deleteObjs;
    }
  }
  loadMore() {
    this.page++;
    this.lodoing = true;
    const params = {
      albumId: this.albumId,
      page: this.page,
      pageSize: 10,
      audit_status: this.activeKey !== '0' ? this.activeKey : '',
      shopId: this.shopId,
    };
    if (this.albumId) {
      this.getAlbumList(params);
    }
  }
}
